<template>
  <VModal ref="modal" @modal:hidden="$emit('hide')" :disable-backdrop-click="updating">
    <div class="mx-auto bg-white rounded-lg text-left shadow-xl lg:max-w-5xl sm:w-full h-full">
      <BaseFetchData :action="fetchAccProductTemplate">
        <template #default="fetchDataProps">
          <div v-if="fetchDataProps.status.loading">
            <Loader />
          </div>
          <div v-else-if="fetchDataProps.status.resolved" class="flex flex-col h-full">
            <div class="flex-none px-4 py-4 sm:px-6 border-b border-gray-200">
              <div class="flex justify-between items-center">
                <div class="flex-1">
                  {{ accProductTemplate.name }}
                </div>
                <div class="flex-none">
                  <button
                    type="button"
                    class="rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    @click="close"
                  >
                    <span class="sr-only">Close</span>
                    <svg
                      class="inline-flex h-6 w-6"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
            <div class="flex-1 h-0">
              <VerticalTabbedNavigation :tabs="tabs">
                <template #before-navigation>
                  <div class="p-4 sm:p-6">
                    <div
                      class="aspect-w-16 aspect-h-9"
                      :class="[(!coverMedia || !coverMedia.url) && 'bg-gray-100 rounded-lg']"
                    >
                      <img
                        v-if="coverMedia && coverMedia.url"
                        :src="coverMedia.url"
                        class="w-full object-cover rounded-lg"
                      />
                      <div v-else class="flex items-center justify-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="h-6 w-6 text-gray-600"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </template>
                <template #default="tabbedSectionProps">
                  <component
                    :is="tabs[tabbedSectionProps.currentTab].component"
                    :acc-product-template-id="accProductTemplateId"
                  />
                </template>
              </VerticalTabbedNavigation>
            </div>
          </div>
        </template>
      </BaseFetchData>
    </div>
  </VModal>
</template>

<script>
import VerticalTabbedNavigation from './VerticalTabbedSection.vue';

export default {
  components: { VerticalTabbedNavigation },
  props: {
    accProductTemplateId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      updating: false,
      destroying: false,
      tabs: [
        {
          name: 'About this Product',
          component: () => import('./About.vue'),
        },
        {
          name: 'Tags',
          component: () => import('./Tags.vue'),
        },
      ],
    };
  },
  computed: {
    accProductTemplate() {
      return this.$store.state.entities.accProductTemplates.byId[this.accProductTemplateId];
    },
    coverMedia() {
      const { coverMediaId = null } = this.accProductTemplate;

      return coverMediaId ? this.$store.state.entities.media.byId[coverMediaId] || null : null;
    },
  },
  methods: {
    close() {
      this.$refs.modal.close();
    },
    async fetchAccProductTemplate() {
      try {
        await this.$store.dispatch('admin/accProductTemplates/read', {
          id: this.accProductTemplateId,
          query: {
            include: 'media,coverMedia',
          },
        });

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async updateAccProductTemplate(formData) {
      try {
        this.updating = true;

        await this.$store.dispatch('admin/accProductTemplates/update', {
          id: this.accProductTemplateId,
          formData,
        });

        this.$emit('updated', this.accProductTemplateId);

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      } finally {
        this.updating = false;
      }
    },
    async destroyAccProductTemplate() {
      try {
        this.destroying = true;

        await this.$store.dispatch('admin/accProductTemplates/destroy', this.accProductTemplateId);

        this.$emit('destroyed', this.accProductTemplateId);
        this.close();

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      } finally {
        this.destroying = false;
      }
    },
  },
  provide() {
    return {
      updateAccProductTemplate: this.updateAccProductTemplate,
      destroyAccProductTemplate: this.destroyAccProductTemplate,
      refreshAccProductTemplate: this.fetchAccProductTemplate,
    };
  },
};
</script>
